<script setup lang="ts">
    import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const permissions = ref([] as any[]);
    const formData = reactive({
        id: "",
        libelle: "",
        description: "",
        codes_permissions: {} as any
    });
    const errors = reactive({
        libelle: "",
        description: ""
    });

    onMounted(() => {
        const form_params: any = route.meta.form_params;
        permissions.value = form_params.permissions;
        if (form_params.role) {
            const role = form_params.role as any;
            formData.id = role.id;
            formData.libelle = role.libelle;
            formData.description = role.description;
            formData.codes_permissions = {};
            role.codes_permissions.forEach((c: any) => {
                formData.codes_permissions[c] = true;
            });
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.libelle = '';
        if (!formData.libelle) {
            errors.libelle ="Le libellé est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                libelle: formData.libelle,
                description: formData.description,
                codes_permissions: Object.keys(formData.codes_permissions).filter((c: any) => formData.codes_permissions[c] === true)
            };
            await axios.post(`/backoffice/roles/save`, formToUpload);
            router.push('/app/roles/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>

        <section class="s7_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5">Rôles / Edition <span class="text-sm text-grey-500"></span></h4>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.libelle" name="libelle" id="libelle" placeholder="">
                    <label for="libelle">Rôle <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['libelle']" class="text-red">{{ errors['libelle'] }}</span>

                <div class="form-field-floating reactive my-4">
                    <textarea class="form-input lg" v-model="formData.description" name="description" id="description" rows="3"></textarea>
                    <label for="description">Description</label>
                </div>
                <span v-if="!!errors['description']" class="text-red">{{ errors['description'] }}</span>
                
            </div>
        </section>

        <section class="s13_mobile px-4">
            <div class="widget px-8 pt-7 pb-9">
                <h4 class="font-semibold mb-0">Permisions</h4>

                <template v-for="(permission, index) of permissions" :key="'permission_' + index">
                    <hr class="mt-7 mb-5"/>
                    <h5 class="font-semibold mb-5">{{ permission.label }}</h5>
                    <div class="grid4 grid-row-gap-1">
                        <div class="card-check color single mb-0" v-for="(childPermission, childIndex) of permission.permissions" :key="'child_permission_' + childIndex">
                            <label class="form-check-label" :for="'cpermission_' + index + '_' + childIndex">
                                <div class="card-check-icon"><img src="/icons/icon-securite-permission.svg" /></div>
                                <div class="card-check-text">
                                    <input class="form-check-input" type="checkbox" name="permissions[]" :id="'cpermission_' + index + '_' + childIndex" v-model="formData.codes_permissions[childPermission.id]" />
                                    <h6>{{ childPermission.label }}</h6>
                                </div>  
                            </label>
                        </div>
                    </div>
                </template>

                <div class="clear-both h-30"></div>
                <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>
                <p class="text-text-xs text-grey-500 mb-5"><b class="color-danger text-xs">*</b> Les champs marqués d'un astérisque sont obligatoires</p>
                <div class="flex gap-2">
                    <custom-button id="btn-submit" type="button" :classesList="'btn lg'" :loading="loading" @click="onSubmit()">
                        <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                        <span>Enregistrer</span>
                    </custom-button>
                    <button class="btn stroke black lg">
                        <span>Effacer</span>
                    </button>
                </div>
            </div>
        </section>
        
    </section>
</template>
